export default "__VITE_ASSET__D1HbF$rl__"